export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    const userAgent = useRequestHeaders()['user-agent']
    const isMobile = /mobile/i.test(userAgent)
    to.meta.isMobile = isMobile
  }
})